export const addItemToLocalStorage = (key: string, item: string): void =>
   localStorage.setItem(key, item)

export const removeItemFromLocalStorage = (key: string): void =>
   localStorage.removeItem(key)

export const getItemFromLocalStorage = (key: string): string | null =>
   localStorage.getItem(key)
